import { CreditCard, FileCheck2, MoreHorizontal, Pencil, Trash2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import type { Transaction } from '../types'

type Props = { tx: Transaction; onEdit: () => void; onPay: () => void; onEDoc: () => void; onDelete: () => void }

export function TxRowMenu({ tx, onEdit, onPay, onEDoc, onDelete }: Props) {
  const { t } = useTranslation()
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="size-8 text-muted-foreground" aria-label={t('finance.rowActions', { name: tx.docNo || tx.description })}>
          <MoreHorizontal />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-52">
        <DropdownMenuItem onSelect={onEdit}>
          <Pencil />
          {t('common.edit')}
        </DropdownMenuItem>
        {tx.status !== 'paid' ? (
          <DropdownMenuItem onSelect={onPay}>
            <CreditCard />
            {t(tx.kind === 'income' ? 'finance.pay.addIn' : 'finance.pay.addOut')}
          </DropdownMenuItem>
        ) : null}
        {tx.kind === 'income' ? (
          <DropdownMenuItem onSelect={onEDoc}>
            <FileCheck2 />
            {t('finance.edoc.create')}
          </DropdownMenuItem>
        ) : null}
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={onDelete} className="text-destructive [&_svg]:text-destructive">
          <Trash2 />
          {t('common.delete')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
